import { useAuthStore } from '@/features/auth/useAuthStore.js'

export function authGuard(to, from, next) {
  const authStore = useAuthStore()

  const token = to?.query?.token

  if (token) {
    authStore.setUserToken(token)
    next(to.path)
  }

  if (!authStore.isLoggedIn) {
    const _redirectUrl = to.fullPath
    const isLogin = window.location.pathname.includes('auth/login')

    function getRedirectUrl() {
      if (isLogin) {
        return ''
      }

      return _redirectUrl
    }

    const redirectUrl = getRedirectUrl()

    const params = new URLSearchParams()

    if (redirectUrl) {
      params.set('redirectUrl', redirectUrl)
    }

    next(`/auth/login?${params.toString()}`)
    return
  }

  next()
}
